import { useEffect, useState } from 'react';
import { Table } from './styles/AXSTable.styled';
import { AXSTableHead } from './AXSTableHead';
import { AXSTableBody } from './AXSTableBody';
import { AXSTableFoot } from './AXSTableFoot';
import { TableHeadRow, TableRowHead } from './styles/AXSTableHead.styled';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import { SpinnerContainer } from '../LoadingSpinner/styles/LoadingSpinner.styled';
import { MappedVacationsRequest } from 'src/components/Timeoff/widgets/RequestsWidget/models/RequestWidget.interface';
import { TableRowEnum } from 'src/components/Timeoff/widgets/RequestsWidget/RequestsWidget';
import { ITEMS_PER_PAGE } from './constants/AXSTable.constants';
import {
  KeyRoots,
  generateReactKey,
} from 'src/utils/generateUniqueReactKey/generateUniqueReactKey';

interface AXSTableProps {
  headerData: JSX.Element[][];
  requests: MappedVacationsRequest[];
  tableRow: TableRowEnum[];
  requestIdHandler: (requestId: string) => void;
  showRequestPopup: () => void;
  loadingRequest: boolean;
}

export const AXSTable = ({
  requests,
  tableRow,
  requestIdHandler,
  showRequestPopup,
  headerData,
  loadingRequest,
}: AXSTableProps) => {
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  const currentPageData = requests.slice(startIndex, endIndex);

  const totalPages = Math.ceil(requests.length / ITEMS_PER_PAGE);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleRequestDetails = (requestId: string) => {
    requestIdHandler(requestId);
    showRequestPopup();
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [loadingRequest]);

  return (
    <Table>
      <TableRowHead>
        <TableHeadRow>
          {headerData.map((header, index) => {
            return (
              <AXSTableHead
                key={generateReactKey(KeyRoots.TIME_OFF_HEADER_DATA, index)}
                headerData={header}
              />
            );
          })}
        </TableHeadRow>
      </TableRowHead>
      {!loadingRequest ? (
        <>
          <AXSTableBody
            requests={currentPageData}
            tableRow={tableRow}
            handleRequestDetails={handleRequestDetails}
          />
          <AXSTableFoot
            handlePageChange={handlePageChange}
            currentPage={currentPage}
            totalPages={totalPages}
          />
        </>
      ) : (
        <SpinnerContainer absolute>
          <LoadingSpinner />
        </SpinnerContainer>
      )}
    </Table>
  );
};
